import { render, staticRenderFns } from "./Noti.vue?vue&type=template&id=5d86c174"
import script from "./Noti.vue?vue&type=script&lang=js"
export * from "./Noti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports